import React from 'react';
import './StaffAugIntro.css';
import SFAIMG from '../../assets/images/Staff_Augmentation.png'; 

const StaffAugIntro = () => {
  return (
    <section className="staff-aug-intro-section">
      <div className="container">
        <div className="staff-aug-intro-grid">
          <div className="staff-aug-text-content">
            <h2 className="staff-aug-title">Transform Your Workforce with Tailored Staffing Solutions</h2>
            <p>
              We offer top SAP staff augmentation services in the UAE, providing expert professionals to enhance your team’s capabilities. Our SAP staff augmentation solutions are designed to seamlessly integrate with your existing team, ensuring project success. As the best SAP staffing consultant services in the UAE, we provide professionals with the expertise needed for your projects. Our staff augmentation services company offers flexible solutions to meet your organization’s needs. We provide SAP staff augmentation services that ensure the successful implementation and support of SAP systems.
            </p>
          </div>
          <div className="staff-aug-image-container">
            <img 
              src={SFAIMG}
              alt="Staff Augmentation" 
              className="staff-aug-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default StaffAugIntro;
